import { render, staticRenderFns } from "./StudyAiChat.vue?vue&type=template&id=34f7c81f&scoped=true"
import script from "./StudyAiChat.vue?vue&type=script&lang=js"
export * from "./StudyAiChat.vue?vue&type=script&lang=js"
import style0 from "./StudyAiChat.vue?vue&type=style&index=0&id=34f7c81f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f7c81f",
  null
  
)

export default component.exports